<template>
    <div class="min-w-360 rounded border bg-primary-5 p-24">
        <p class="text-heading-2 font-semibold mb-12">{{ $t('multi-posting.tabs.social-boosts.request-social-boost.title') }}</p>
        <div class="grid grid-cols-1 gap-24">
            <p> {{ $t('multi-posting.tabs.social-boosts.request-social-boost.description') }} </p>
            <div class="space-y-12">
                <select-dropdown
                    v-model="selectedJob"
                    whiteBackground
                    :options="mappedJobs"
                    :placeholder="$t('general.select')"
                    :loading="loadingJobs"
                    :auto-translate="false"
                    :disabled="!hasJobs"
                    :input-label="$t('multi-posting.tabs.social-boosts.request-social-boost.vacancy.label')"
                />
                <select-dropdown
                    v-model="selectedSocialBoost"
                    whiteBackground
                    :loading="fetchingBoosters"
                    :options="mappedBoosters"
                    :auto-translate="false"
                    :placeholder="$t('general.select')"
                    :disabled="!hasSocialBoosts"
                    :input-label="$t('multi-posting.tabs.social-boosts.request-social-boost.social-boost.label')"
                />
            </div>
            <simple-button
                display="secondary"
                look="primary"
                class="w-full"
                :uppercase="false"
                @click="requestSocialBoost">
                {{ $t('multi-posting.tabs.social-boosts.request-social-boost.request-social-boost.label') }}
            </simple-button>
        </div>
    </div>
</template>

<script>
import SvgIcon from "../../ui/SvgIcon.vue";
import SimpleButton from "../../ui/SimpleButton.vue";
import SelectDropdown from "../../forms/SelectDropdown.vue";
import Job from "../../../models/Job";
import {mapState, mapActions} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../../state/store';
import {useJobsStore} from '../../../state/modules/jobs';
import {useMultiPostingStore} from '../../../state/modules/multiPosting';

export default {
    name: 'SocialBoostRequest',
    components: {
        SimpleButton,
        SvgIcon,
        SelectDropdown,
    },
    data() {
        return {
          selectedJob: null,
          selectedSocialBoost: null,
          loadingJobs: false,
          fetchingBoosters: false
        }
    },
    computed: {
        ...mapState(useMainStore, ['selectedLocale']),
        ...mapState(useMultiPostingStore, ['boosters']),
        locale() {
            return this.selectedLocale;
        },
        hasJobs() {
            return true;
        },
        hasSocialBoosts() {
            return this.boosters && this.boosters.length > 0;
        },
        jobs() {
            return useRepo(Job)
                .where('published', true)
                .get();
        },
        mappedJobs() {
            return this.jobs
                .map(job => ({ value: job.id, label: job.title[this.locale] }));
        },
        mappedBoosters() {
            return this.boosters
                .map(booster => ({ value: booster.id, label: booster.title[this.locale] }));
        }
    },
    methods: {
        ...mapActions(useJobsStore, ['fetch']),
        ...mapActions(useMultiPostingStore, ['fetchBoosters']),
        requestSocialBoost() {
            if (!this.selectedJob || !this.selectedSocialBoost) {
                // TODO: add error handling form
                return;
            }
            this.$emit('request-booster', {
                socialBoost: this.boosters.find(x => x.id === this.selectedSocialBoost),
                job: this.jobs.find(x => x.id === this.selectedJob)
            });
        },
        loadJobs() {
            this.loadingJobs = true;
            this.fetch({activeState: 'active', all: 1}).then(() => {
                this.loadingJobs = false;
            });
        },
        loadBoosters() {
            this.fetchingBoosters = true;
            this.fetchBoosters().then(() => {
                this.fetchingBoosters = false;
            });
        },
    },
    mounted() {
        this.loadJobs();
        this.loadBoosters();
    }
}
</script>
